// Copyright (C) 2017-2023 Smart code 203358507

const MetaPreview = require('./MetaPreview');

module.exports = MetaPreview;
